// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__P95ib","input":"Input_input__0Qa8A","label":"Input_label__oGMw1","error":"Input_error__JZD7E"};